import { Component, DoCheck, ElementRef, EventEmitter, HostBinding, Input, Output, TemplateRef } from '@angular/core';

import { PowerFlowGraphMode, pathIcons } from './power-state.utils';

export const getLabels = () => ({
  home: 'Home',
  grid: 'Grid',
  solar: 'Solar',
  battery: 'Battery',
  disconnected: 'Disconnected',
  unit: 'Unit',
});

@Component({
  selector: 'ngx-power-state',
  templateUrl: './power-state.component.html',
  styleUrls: ['./power-state.component.scss'],
})
export class PowerStateComponent implements DoCheck {
  readonly _labels = getLabels();
  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
  }
  get labels(): typeof this._labels {
    return this._labels;
  }

  @Input() mode: PowerFlowGraphMode | null = null;
  @Input() disconnected? = false;

  @Input() showPowerFlow: boolean = true;
  @Input() duration = 2;
  @Input() fromGridToHome?: number;
  @Input() fromSolarToGrid?: number;
  @Input() fromSolarToHome?: number;
  @Input() fromSolarToBattery?: number;
  @Input() fromGridToBattery?: number;
  @Input() fromBatteryToHome?: number;
  @Input() solar?: number;
  @Input() home?: number;
  @Input() grid?: number;
  @Input() batteryPercentage?: number | string;
  @Input() batteryPower?: number | string;
  @Input() lastUpdated?: Date | null | undefined;
  @Input() offset?: number | null | undefined;
  @Input() showSeconds = false;
  @Input() unitSymbol = 'W';
  @Input() valuePrecision = 0;

  @Input() extPowerTemplate?: TemplateRef<any>;

  @Output() nodeClick =new EventEmitter<'battery'|'solar'|'grid'|'home'>();

  readonly _pathIcons = pathIcons;
  @Input() set pathIcons(value: Partial<typeof pathIcons>) {
    Object.assign(this._pathIcons, value);
  }
  get pathIcons() {
    return this._pathIcons;
  }

  private width = 0;
  @HostBinding('class.short') isSmallWidth: boolean = false;

  constructor(private readonly elementRef: ElementRef) {}

  ngDoCheck(): void {
    const width = this.elementRef.nativeElement.clientWidth;
    if (width !== this.width) {
      this.width = width;
      this.isSmallWidth = this.width < 320;
    }
  }
}
